import {
  useContext,
  createContext,
  useEffect,
  useState,
  useCallback,
} from "react";

const SearchContext = createContext();
export const useSearch = () => useContext(SearchContext);

export function SearchProvider({ children }) {
  const [openSearch, setOpenSearch] = useState(false);

  const toggleOpen = useCallback(() => {
    setOpenSearch((prev) => !prev);
  }, []);

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.altKey && event.key.toLowerCase() === "k") {
        event.preventDefault();
        // console.log("Alt + K was pressed!");
        toggleOpen();
      }
    };

    // Add listener to the window
    window.addEventListener("keydown", handleKeyDown);

    // Clean up the listener when the component unmounts
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [toggleOpen]);

  const value = { openSearch, setOpenSearch, toggleOpen };
  return (
    <SearchContext.Provider value={value}>{children}</SearchContext.Provider>
  );
}
